export default __webpack_public_path__ + "static/media/whyDoesErika.e822ab16.wav";